import { defineComponent } from "@/utils/define-component";
import barba from "@barba/core";

function setUrlParam(key, value = "") {
  const url = new URL(window.location.href);

  if (value === null) {
    url.searchParams.delete(key);
  } else {
    url.searchParams.set(key, value);
  }

  barba.history.add(url.href, "popstate", "replace");
}

export default defineComponent(() => ({
  isOpen: false,

  cartMarkup: null,

  onUpdate() {
    this.open();

    this.$refs.drawerScrollContent.scrollTo({ top: 0, behavior: "smooth" });
  },

  async render() {
    const res = await fetch("/cart");
    const text = await res.text();
    const cart = new DOMParser()
      .parseFromString(text, "text/html")
      .querySelector("[data-shopify-content]");

    if (document.startViewTransition) {
      document.startViewTransition(() => {
        this.cartMarkup = cart.outerHTML;
      });
    } else {
      this.cartMarkup = cart.outerHTML;
    }
  },

  async open(e?: Event) {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }

    this.isOpen = true;

    window.dispatchEvent(
      new CustomEvent("is-loading", {
        detail: { id: "cart-drawer", isLoading: true },
      }),
    );

    await this.render();

    setUrlParam("cart");

    window.dispatchEvent(
      new CustomEvent("is-loading", {
        detail: { id: "cart-drawer", isLoading: false },
      }),
    );

    setTimeout(() => {
      this.$root.classList.add("no-animation");
    }, 500);
  },

  close() {
    this.isOpen = false;

    setUrlParam("cart", null);

    setTimeout(() => {
      this.cartMarkup = null;
      this.$root.classList.remove("no-animation");
    }, 300);
  },

  init() {
    const searchParams = new URLSearchParams(window.location.search);
    if (searchParams.has("cart")) {
      this.open();
    }
  },
}));
